import React, { useState, createContext } from "react";

// Create a context for the navigation state
export const NavigationContext = createContext();

const NavigationProvider = ({ children }) => {
    const [open, setOpen] = useState({
        isAccount: false,
        isOrder: false,
        isNotification: false,
        isVoucher: false,
    });
    const [openChild, setOpenChild] = useState({
        isProfile: false,
        isBank: false,
        isResetPass: false,
    });

    return (
        <NavigationContext.Provider
            value={{ open, setOpen, openChild, setOpenChild }}
        >
            {children}
        </NavigationContext.Provider>
    );
};
export default NavigationProvider;